export type GeoModel = 'jobs' | 'orders' | 'loads' | 'driver_days';

/**
 * Computes the navigation target when the user picks a different entity in the
 * Geo admin typeahead. For jobs we preserve the current sub-section (distances
 * vs. geofences) and any geofences bottom-tab segment in the URL; other models
 * always go to the distances view.
 */
export function buildEntitySelectPath({
  currentModel,
  pathname,
  selectedId,
  geoBasePath,
}: {
  currentModel: GeoModel;
  pathname: string;
  selectedId: string;
  geoBasePath: string;
}): string {
  const base = `${geoBasePath}/${currentModel}`;
  if (currentModel !== 'jobs') {
    return `${base}/${selectedId}/distances`;
  }
  if (pathname.includes('/distances')) {
    return `${base}/${selectedId}/distances`;
  }
  const match = pathname.match(/\/geofences\/([^/]+)/);
  const bottomTab = match?.[1] ?? '';
  return bottomTab
    ? `${base}/${selectedId}/geofences/${bottomTab}`
    : `${base}/${selectedId}/geofences`;
}
